var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center loader"},[_c('v-progress-circular',{class:[!_vm.noMargins ? 'my-4' : ''],attrs:{"fill-height":"","indeterminate":_vm.completed ? false : true,"size":_vm.size,"width":_vm.width ? _vm.width : _vm.computedWidth,"value":_vm.completed ? '100' : '30',"color":_vm.color}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }